import Welcome from './Welcome.vue'
export default Welcome;
